// extracted by mini-css-extract-plugin
module.exports = {"glossaryContent":"TheoryBookContainer_glossaryContent__1yiZW","glossaryScrollBox":"TheoryBookContainer_glossaryScrollBox__2uovs"};